(function ($) {
    'use strict';

    var SELECTOR = '[data-form-create-lease]';
    var READY_SELECTOR = '[data-form-lease-ready]';
    var FORM_CREATE_LEASE_API_URL = '/:lang/api/forms/:id/create-lease';
    var FORM_LEASE_READY_API_URL = '/:lang/api/forms/:id/lease-ready';

    var $html = $('html');
    var $body = $('body');

    var FormCreateLease = {};

    FormCreateLease.getFormCreateLeaseApiUrl = function (formId) {
        return FORM_CREATE_LEASE_API_URL
            .replace(':lang', $html.attr('lang'))
            .replace(':id', formId)
        ;
    };

    FormCreateLease.getFormLeaseReadyApiUrl = function (formId) {
        return FORM_LEASE_READY_API_URL
            .replace(':lang', $html.attr('lang'))
            .replace(':id', formId)
        ;
    };

    FormCreateLease.onChangeFormLeaseReady = function (event) {
        event.preventDefault();

        var $element = $(this),
            formId = $element.data('form-lease-ready'),
            $createLease = $('[data-form-create-lease="'+formId+'"]'),
            createLeaseDisabled = $createLease.prop('disabled'),
            apiUrl = FormCreateLease.getFormLeaseReadyApiUrl(formId),
            value = $element.prop('checked') ? 1 : 0
        ;

        $createLease.prop('disabled', true);

        if ($element.data('form-create-lease.state')) {
            return;
        }

        $element.data('form-create-lease.state', 'loading');
        $element.addClass('is-loading');

        $.ajax(apiUrl, {
            method: 'POST',
            data: {
                value: value
            }
        })
            .done(function(data) {
                if (! data.ok) {
                    console.error('unknow error');
                    return;
                }

                $createLease.prop('disabled', ! value);
            })
            .fail(function () {
                $createLease.prop('disabled', createLeaseDisabled);
            })
            .always(function () {
                $element.data('form-create-lease.state', null);
                $element.removeClass('is-loading');
            })
        ;
    };

    FormCreateLease.onClickFormCreateLease = function (event) {
        event.preventDefault();

        var $element = $(this),
            formId = $element.data('form-create-lease'),
            apiUrl = FormCreateLease.getFormCreateLeaseApiUrl(formId)
        ;

        $element.data('form-create-lease.state', 'loading');
        $element.addClass('is-loading');

        $.ajax(apiUrl, {
            method: 'POST'
        })
            .done(function(data) {
                if (! data.ok) {
                    console.error('unknow error');
                    return;
                }

                window.location.assign(data.location);
            })
            .always(function () {
                $element.data('form-create-lease.state', null);
                $element.removeClass('is-loading');
            })
        ;
    };

    $(document).ready(function () {
        $body.on('click.form-create-lease', SELECTOR, FormCreateLease.onClickFormCreateLease);
        $body.on('change.form-create-lease', READY_SELECTOR, FormCreateLease.onChangeFormLeaseReady);
    });

})(require('jquery'));
